import React, { FC } from 'react';

import { alpha, styled, Typography } from '@mui/material';

import InfoIcon from '~/assets/icons/InfoIcon';
import { LightTooltip } from '~/components/UI/LightTooltip/LightTooltip';
import { TINY_MARGIN, TINY_MARGIN_PX } from '~/theme';

interface ImpactProps {
  text?: string;
  tooltipText?: string;
}

const Impact: FC<ImpactProps> = ({ text, tooltipText }) => {
  if (!text || !tooltipText) return null;

  return (
    <Wrapper data-testid="impactWrapper">
      <Text>{text}</Text>
      <LightTooltip title={tooltipText} placement="top">
        <IconWrapper>
          <StyledInfoIcon />
        </IconWrapper>
      </LightTooltip>
    </Wrapper>
  );
};

export default Impact;

const Wrapper = styled('div')`
  display: flex;
  gap: ${TINY_MARGIN_PX};
  align-items: center;
  max-height: max-content;
  padding: ${TINY_MARGIN / 2}px 0;
`;
const Text = styled(Typography)`
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.common.text.gray};
`;
const IconWrapper = styled('div')`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-items: center;

  & > svg {
    width: 15px;
    height: 15px;
  }
`;
const StyledInfoIcon = styled(InfoIcon)`
  color: ${({ theme }) => alpha(theme.palette.common.white, 0.33)};
  transition: color 0.3s;
  &:hover {
    color: ${({ theme }) => theme.palette.common.hint.color};
  }
`;
